<template lang="pug">
input(v-model="model", v-on="inputListeners")
</template>

<script>
	export default {
		name: 'InputEmail',
		data() {
			return {
				model: null
			};
		},
		props: {
			value: {
				required: true
			}
		},
		computed: {
			inputListeners() {
				const vm = this;
				return Object.assign({}, this.$listeners, {
					input(event) {
						if(event.target.value == "") {
							vm.model = null;
						};
						vm.$emit('input', vm.model);
					}
				});
			}
		},
		watch: {
			value(newValue) {
				this.model = newValue;
			}
		}
	};
</script>



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-input-email/DNFORM-input-email.vue